import React, { useEffect, useState } from "react";
import { getOffices } from "../actions/ApiCalls";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";

function Offices() {
    const [headOffices, setHeadOffices] = useState<any[]>([]);
    const [regionalOffices, setRegionalOffices] = useState<any[]>([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

    useEffect(() => {
        window.scrollTo(0,0)
        getOffices()
            .then(response => {
                setHeadOffices(response.data.head_offices);
                setRegionalOffices(response.data.regional_offices);
            })
            .catch(error => {
                console.error("Failed to fetch offices:", error);
            });
    }, []);

    function toTitleCase(str: string) {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 576);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            // overflow: 'hidden'
        }}>
        <Header />
            <div
                style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    // gap: "10px",
                    padding: "20px",
                    marginTop: "100px",
                }}
            >
                <div style={{ flex: 1 }}></div>
                <div style={{ flex: 1, textAlign: "left", marginLeft: window.innerWidth > 575 ? '40px' : 0}}>
                    <p style={{ fontWeight: 600, textTransform: "uppercase" }}>
                        Contact
                    </p>
                    <p style={{ width: window.innerWidth > 575 ? '65%' : '100%', marginBottom: "10px", fontWeight: 400 }}>
                        Please see below information for contacting Vinimark and its offices.
                    </p>
                    <br /><br />
                    <div style={{ display: "flex", flexDirection: "row", width: window.innerWidth > 575 ? '65%' : '100%', minWidth: '300px' }}>
                        <div style={{ flex: 1, display: "flex", flexDirection: "column"  }}>
                        {/*  Regional Offices  */}
                            <p style={{fontWeight: 400}}>Regional Offices</p>
                            {regionalOffices.map((office, index) => (
                                <div key={index} style={{width: '80%', marginBottom: '13px' }}>
                                    <p style={{marginBottom: 0, marginTop: 0, fontWeight: 400}}>{toTitleCase(office.province)}</p>
                                    {office.address_line_1 ? <p style={{marginBottom: 0, marginTop: 0, fontWeight: 400}}>{office?.address_line_1}, {office?.address_line_2} {office?.postal_code} </p> : <></>}
                                    {office.tel ? <p style={{marginBottom: 0, marginTop: 0, fontWeight: 400}}>t: {office?.tel}</p> : <></>}
                                    {office?.geo_url ? (
                                        <a
                                            style={linkStyle}
                                            href={office.geo_url.startsWith('http') ? office.geo_url : `https://${office.geo_url}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            directions
                                        </a>
                                    ) : null}
                                </div>
                            ))}

                        </div>
                        <div style={{ flex: 1, display: "flex", flexDirection: "column", width: '90%' }}>
                            {/*  Head Offices  */}
                            <p style={{fontWeight: 400}}>Head Office</p>
                            {headOffices?.map((office, index) => (
                                <div key={index}>
                                    <p style={{marginBottom: 0, marginTop: 0, fontWeight: 400}}>e: info@vinimark.co.za</p>
                                    {office.address_line_1 ? <p style={{marginBottom: 0, marginTop: 0, fontWeight: 400}}>{office?.address_line_1}, {office?.address_line_2} {office?.postal_code} </p> : <></>}
                                    {office.tel ? <p style={{marginBottom: 0, marginTop: 0, fontWeight: 400}}>t: {office?.tel}</p> : <></>}
                                    {office?.geo_url ? (
                                        <a
                                            style={linkStyle}
                                            href={office.geo_url.startsWith('http') ? office.geo_url : `https://${office.geo_url}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            directions
                                        </a>
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Offices;
